/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_socialactions_actions_retweet1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리트윗`)
};

const en_socialactions_actions_retweet1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retweet`)
};

const ja_socialactions_actions_retweet1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リツイート`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const socialactions_actions_retweet1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.socialactions_actions_retweet1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("socialactions_actions_retweet1", locale)
	if (locale === "ko") return ko_socialactions_actions_retweet1(inputs)
	if (locale === "en") return en_socialactions_actions_retweet1(inputs)
	return ja_socialactions_actions_retweet1(inputs)
};
export { socialactions_actions_retweet1 as "socialActions_actions_retweet" }